import React from 'react'
import { Link } from 'react-router-dom'
import './imgbox.css'

const ImageBox = ({src, link}) => {
    return (
        <div className='image-box'>
            {link ?
            <Link to={link}>
                <img src={src} alt="Brand" />
            </Link>
            :
            <img src={src} alt="Brand" />
            }
        </div>
    )
}

export default ImageBox